import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { RenderProductSizesModalComponent } from 'render/render-shared/ui/render-product-sizes/render-product-sizes-modal/render-product-sizes-modal.component';

import { AdditionalInfoPipe, ColorSizesPipe, ThresholdLabelPipe, ViewSimilarProductsPipe } from './pipes/product-purchase.pipes';
import { RenderProductPurchaseOptionsComponent } from './render-product-purchase-options.component';


@NgModule({
  declarations: [
    RenderProductPurchaseOptionsComponent,
    RenderProductSizesModalComponent,
    ThresholdLabelPipe,
    AdditionalInfoPipe,
    ViewSimilarProductsPipe,
    ColorSizesPipe
  ],
  imports: [
    CommonModule,
    RenderSharedModule,
  ],
  exports: [
    RenderProductPurchaseOptionsComponent,
    RenderProductSizesModalComponent
  ]
})
export class RenderProductPurchaseOptionsModule { }
